<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >

    <FormItem label="选择平台" prop="live_id">
        <Select v-model="formValidate.live_id" clearable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="账户名" prop="name">
        <Input v-model="formValidate.name" placeholder="请填写账户名"></Input>
      </FormItem>
    
      <FormItem label="cookie" prop="cookie">
        <Input type="textarea" v-model="formValidate.cookie" placeholder="请填写cookie"></Input>
      </FormItem>
      
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import {getLiveType} from "@/api/data";
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      liveIds:[],
      formValidate: {
        id: '',
        live_id: '',
        name: '',
        cookie: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '账户名不能为空',
            trigger: 'blur'
          }
        ],
        cookie: [
          {
            required: true,
            message: 'cookie不能为空',
            trigger: 'blur'
          }
        ],
        live_id: [
          {
            required: true,
            message: '需要选择平台',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setLiveType(live_list) {
      var data = new Array()
      for (var i = 0; i < live_list.length; i++) {
        data[i] = { id: live_list[i].id.toString(), name: live_list[i].name }
      }
      this.liveIds = data
    },
    setEditData (editData) {

      this.formValidate.id = editData.id
      this.formValidate.live_id = editData.live_id.toString()
      this.formValidate.name = editData.name
      this.formValidate.cookie = editData.cookie

    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
